import Vue from 'vue'
const state = {
  idItems: []
}

const getters = {
  idItems(state) {
    return state.idItems
  },
  idItemParIndex(state, index) {
    if (index < 0 || index > state.idItems.length) {
      return null
    }
    return state.idItems[index]
  }
}

const actions = {
  setterIdItems({ commit }, idItems) {
    commit('mSetterIdItems', idItems)
  },
  resetIdItems({ commit }) {
    commit('mResetIdItems')
  }
}

const mutations = {
  mSetterIdItems(state, idItems: number) {
    state.idItems = idItems
    state.currentIx = 0
  },
  mResetIdItems(state) {
    state.idItems = []
    state.currentIx = -1
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
